import http from '@/utils/http.js' // 引入封装的request.js文件
import common from '@/config/common.js'

// 暴露出我们的接口请求,export导出
export function queryCourseList(data) {
    return http.request({
        url: common.url + '/papi/course/list',
        method: 'get',
        params: data
    })
}

// 试学课程
export function tryPlayCourse(data) {
    return http.request({
        url: common.url + '/papi/course/tryPlay',
        method: 'get',
        params: data
    })
}

// 暴露出我们的接口请求,export导出
export function querymyCourseList(data) {
    return http.request({
        url: common.url + '/papi/course/myCourseList',
        method: 'get',
        params: data
    })
}

//获取课程详情
export function queryCourseById(data) {
    return http.request({
        url: common.url + '/papi/queryCourseById',
        method: 'get',
        params: data
    })
}

//获取最喜欢课程列表
export function queryFavoriteCourseList(data) {
    return http.request({
        url: common.url + '/papi/favoriteCourseList',
        method: 'get',
        params: data
    })
}